import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

type Props = {
  children: React.ReactNode;
};

function Main({ children }: Props) {
  return (
    <Box
      component="main"
      sx={(theme) => ({
        display: 'flex',
        direction: 'column',
        flex: '1 1 auto',
        backgroundColor: theme.palette.grey[100],
      })}
    >
      <Container maxWidth={false} disableGutters>
        {children}
      </Container>
    </Box>
  );
}

export default Main;
